import { render, staticRenderFns } from "./studentsPptList.vue?vue&type=template&id=6754c60e&scoped=true"
import script from "./studentsPptList.vue?vue&type=script&lang=js"
export * from "./studentsPptList.vue?vue&type=script&lang=js"
import style0 from "./studentsPptList.vue?vue&type=style&index=0&id=6754c60e&prod&lang=css"
import style1 from "./studentsPptList.vue?vue&type=style&index=1&id=6754c60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6754c60e",
  null
  
)

export default component.exports